export class ChildSimilarCaseUserDecision {
    markedAsNoSimilar: boolean;
}
